<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">
                <v-row>
                    <v-col
                            cols="12"
                            md="8"
                            offset-md="2"
                    >
                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Organisations') }}</h1>
                        <v-card
                                class="mx-auto info-card"
                                outlined
                        >
                            <v-card-title class="headline primary--text">{{ $t('headings.Get to grips with lost property') }}</v-card-title>

                            <vimeo-player ref="player" video-id="397128650" @ready="onReady" class="player-container" :options="options">
                            </vimeo-player>

                            <v-card-text class="text--primary">

                                <h2 class="title mb-3">{{ $t('headings.Sign up as an organisation to start scanning our Smart tags') }}</h2>
                                <OrganisationsSummary />

                                <OrganisationsContent />

                            </v-card-text>

                            <v-card-actions>
                                <v-btn tile elevation="0" color="primary" @click="navigate('sign-up-organisation')">
                                    {{ $t('buttons.Sign up organisation') }}
                                </v-btn>
                            </v-card-actions>

                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer'
    import {i18n} from "../i18n";
    import OrganisationsSummary from "./OrganisationsSummary";
    import OrganisationsContent from "./OrganisationsContent";
    import {mapState} from "vuex";

    export default {
        name: "Organisations",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Organisations'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Sign up as an organisation to start scanning our Smart tags') + '.' + i18n.t('Lost property in schools, leisure centres, sports clubs, gyms; {brand} has a revolutionary solution', {brand: this.capitalizeFirstLetter(this.brand)}) + '.' }
            ]
          }
        },
        components: {
          OrganisationsSummary,
          OrganisationsContent,
            'Footer': Footer
        },
        data () {
            return {
                options: {'responsive': true, 'dnt': true},
                playerReady: false
            }
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        mounted () {

            this.$gtag.pageview({
                page_path: '/organisations'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            },
            onReady() {
                this.playerReady = true
            },
            play () {
                this.$refs.player.play()
            },
            stop () {
                this.$refs.player.stop()
            },
        }
    }
</script>

<style scoped>
    .v-card__actions {
        padding: 16px;
        justify-content: flex-end;
    }
    .info-card {
        border-radius: 15px;
        border: none !important;
    }
</style>
